
export const levenshteinDistance = (a: string, b: string): number => {
    const matrix = [];

    for (let i = 0; i <= b.length; i++) {
        matrix[i] = [i];
    }

    for (let j = 0; j <= a.length; j++) {
        matrix[0][j] = j;
    }
    for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
                matrix[i][j] = matrix[i - 1][j - 1];
            } else {
                matrix[i][j] = Math.min(
                    matrix[i - 1][j - 1] + 1,
                    Math.min(
                        matrix[i][j - 1] + 1,
                        matrix[i - 1][j] + 1
                    )
                );
            }
        }
    }

    return matrix[b.length][a.length];
};

const normalize = (str: string) => {
    return str.toLowerCase().replace(/[^a-z0-9]/g, '');
};

export const findBestMatch = (target: string, candidates: string[], threshold: number = 3): string | null => {
    let bestMatch = null;
    let minDistance = Infinity;
    const normalizedTarget = normalize(target);

    for (const candidate of candidates) {
        const normalizedCandidate = normalize(candidate);

        if (normalizedTarget === normalizedCandidate) {
            return candidate;
        }

        if (normalizedTarget.includes(normalizedCandidate) || normalizedCandidate.includes(normalizedTarget)) {
        }

        const distance = levenshteinDistance(normalizedTarget, normalizedCandidate);

        if (distance < minDistance && distance <= threshold) {
            minDistance = distance;
            bestMatch = candidate;
        }
    }

    return bestMatch;
};
